import React, { Component } from 'react';
import { Nav, NavItem, NavLink, NavbarToggler, NavbarBrand, } from 'reactstrap';
import { ToastContainer } from 'react-toastify';

import HeaderDropdown from './headerdropdown';

import 'react-toastify/dist/ReactToastify.css';


class Header extends Component {
 sidebarToggle(e) {
  e.preventDefault();
  document.body.classList.toggle('sidebar-hidden');
 }

 sidebarMinimize(e) {
  e.preventDefault();
  document.body.classList.toggle('sidebar-minimized');
 }

 mobileSidebarToggle(e) {
  e.preventDefault();
  document.body.classList.toggle('sidebar-mobile-show');
 }

 render() {
  return (
   <header className="app-header navbar">
    <ToastContainer position="top-right" autoClose={2500} style={{ zIndex: 1999 }}/>

    <NavbarToggler className="d-lg-none" onClick={this.mobileSidebarToggle}>
     <span className="navbar-toggler-icon"></span>
    </NavbarToggler>
    <NavbarBrand></NavbarBrand>
   
    <span className="d-md-down-none"><a href="https://cloudtpv.app" target="_blank" rel="noopener noreferrer">CloudTPV</a> by <a href="https://www.kesthers.com" target="_blank" rel="noopener noreferrer">KesthersCom IT Solutions OÜ</a> &copy; {(new Date()).getFullYear()}</span>

    <Nav className="ml-auto" navbar>
     {/*
     <HeaderDropdown notif/>
     <HeaderDropdown tasks/>
     <HeaderDropdown mssgs/>*/}
     <HeaderDropdown getOut={this.props.getOut} accnt/>
    </Nav>
   </header>
  );
 }
}

export default Header;



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/header.js